(function ($) {
  $('.top-nav .dropdown').click(function(evt) {
    evt.stopPropagation(); //stops the document click action
    $('.top-nav .dropdown').not($(this)).removeClass('clicked');
    $(this).toggleClass('clicked');
  });
  $(document).click(function() {
    $('.top-nav .dropdown').removeClass('clicked'); //make all inactive
  });
});

(function($){
  "use strict"; // Start of use strict
  var stickyHeaderTop =0;
  if( $('.header .main-menu').length > 0){
    stickyHeaderTop = $('.header .main-menu').offset().top;
  }

  $('.owl-carousel').each( function() {
    try{
      var $carousel = $(this);
      var config = $carousel.data();
      //config.dots = $carousel.hasClass('dotData');
      config.navText = ['<i class="fa fa-angle-left "><i>', '<i class="fa fa-angle-right"></i>'];
      $carousel.owlCarousel(config);
      $carousel.on('changed.owl.carousel', function(property) {
        var current = property.item.index;
        $(property.target).find(".owl-item").eq(current).find(".caption").each(function(i) {
          var t = $(this);
          var style = $(this).attr("style");
          style = (style == undefined) ? '' : style;
          var delay = i + 1 * 1000;
          var animate = t.data('animate');
          t.attr("style", style +
                 ";-webkit-animation-delay:" + delay + "ms;" + "-moz-animation-delay:" + delay + "ms;" + "-o-animation-delay:" + delay + "ms;" + "animation-delay:" + delay + "ms;"
                ).addClass('animated ' + animate).one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
            $(this).removeClass('animated ' + animate);
          });

        })
        // $carousel.trigger('refresh.owl.carousel');
      })

    }catch(ex){

    }
  });
  $("#deal_products").owlCarousel({
    items: 1,
    nav: false,
    loop: true,
    navText: ["<i class='fa fa-angle-left'	></i>","<i class='fa fa-angle-right'></i>"],
    dots: false,
    autoplay: false,
    responsive:{
      0 : {
        items: 1}
      ,
      480 : {
        items: 1}
      ,
      768 : {
        items: 2}
      ,
      980 : {
        items: 1}
      ,
      1200 : {
        items: 1}
    }
  }
                                 );
  function topsearch(){
    $("#top-search-trigger").click(function(e){
      $('body').toggleClass('top-search-open');
      e.stopPropagation();
      e.preventDefault();
    });

  }
/**
    *-------------------------------------------------------------------------------------------------------------------------------------------
    * mobile responsive navigation 
    *-------------------------------------------------------------------------------------------------------------------------------------------
    */

  function mobileNavigation() {

    var body = $("body"),
        mobileNav = $(".mobile-nav"),
        dropDownCat = $(".mobile-nav .site-mobile-menu .menu-item-has-children"),
        elementIcon = '<span class="icon-sub-menu"></span>',
        butOpener = $(".icon-sub-menu");

    dropDownCat.append(elementIcon);

    mobileNav.on("click", ".icon-sub-menu", function(e) {
      e.preventDefault();

      if ($(this).parent().hasClass("opener-page")) {
       // $(this).parent().removeClass("opener-page").find("> ul").slideUp(200);
        $(this).parent('li').removeClass("opener-page").children(".sub-menu-dropdown").children('.container').children('ul').slideUp(200);
        $(this).parent().find('> .icon-sub-menu').removeClass("up-icon");
      } else {
       // $(this).parent().addClass("opener-page").find("> ul").slideDown(200);
        $(this).parent('li').addClass("opener-page").children(".sub-menu-dropdown").children('.container').children('ul').slideDown(200);
        $(this).parent().find('> .icon-sub-menu').addClass("up-icon");
      }
    });

    $(".mobile-nav-icon ").click(function(e) {
      $('body').toggleClass('nav-mobile-open');
      if ($('body').hasClass('nav-mobile-open')) {
        $('.basel-close-side').click(function(ev){
          $('body').removeClass('nav-mobile-open');
          e.stopPropagation();
        });
      }
      e.stopPropagation();
      e.preventDefault();
    });
  }
  /* ---------------------------------------------
     Stick menu
     --------------------------------------------- */
  function kt_stick_menu(){
    if($('#header .main-menu').length >0){
      var h = $(window).scrollTop();
      var width = $(window).width();
      if(width > 991){
        if((h > stickyHeaderTop) ){
          $('#header').addClass('on-sticky');
        }else{
          $('#header').removeClass('on-sticky');
        }
      }else{
        $('#header').removeClass('on-sticky');
      }
    }
  }

  /* ---------------------------------------------
     SELECT CHOSEN
     --------------------------------------------- */
  function kt_hiden_orther_veticalmenu(){

    if( $( '.box-vertical-megamenus' ).length > 0 ){
      var all_item = 0;
      var limit_item = $('.box-vertical-megamenus').data('items')-1;

      var all_item = $('.box-vertical-megamenus .verticalmenu-list>li').length;
      if( all_item > (limit_item + 1) ){
        $('.box-vertical-megamenus').addClass('show-button-all');
      }else{
        $('.box-vertical-megamenus').addClass('hiden-button-all');
      }

      $('.box-vertical-megamenus').find('.verticalmenu-list>li').each(function(i){
        all_item = all_item + 1;
        if(i > limit_item){
          $(this).addClass('orther-link');
        }
      })
    }
  }

  /** ALL CAT **/
  $(document).on('click','.box-vertical-megamenus .viewall.closed',function(){
    $(this).closest('.box-vertical-megamenus').find('li.orther-link').each(function(){
      $(this).slideDown();
    });
    var closetext = $(this).data('closetext');
    $(this).addClass('open').removeClass('closed').html( closetext );
    return false;
  });

  /* Close category */
  $(document).on('click','.box-vertical-megamenus .viewall.open',function(){
    $(this).closest('.box-vertical-megamenus').find('li.orther-link').each(function(){
      $(this).slideUp();
    });
    var opentext = $(this).data('opentext');
    $(this).addClass('closed').removeClass('open').html(opentext);
    return false;
  });

  /* ---------------------------------------------
     ResponsiveClasses
     --------------------------------------------- */
  function kt_responsiveClasses(){
    var jRes = jRespond([
      {
        label: 'smallest',
        enter: 0,
        exit: 479
      },{
        label: 'handheld',
        enter: 480,
        exit: 767
      },{
        label: 'tablet',
        enter: 768,
        exit: 991
      },{
        label: 'laptop',
        enter: 992,
        exit: 1199
      },{
        label: 'desktop',
        enter: 1200,
        exit: 10000
      }
    ]);
    jRes.addFunc([
      {
        breakpoint: 'desktop',
        enter: function() { $('body').addClass('device-lg'); },
        exit: function() { $('body').removeClass('device-lg'); }
      },{
        breakpoint: 'laptop',
        enter: function() { $('body').addClass('device-md'); },
        exit: function() { $('body').removeClass('device-md'); }
      },{
        breakpoint: 'tablet',
        enter: function() { $('body').addClass('device-sm'); },
        exit: function() { $('body').removeClass('device-sm'); }
      },{
        breakpoint: 'handheld',
        enter: function() {$('body').addClass('device-xs'); },
        exit: function() { $('body').removeClass('device-xs'); }
      },{
        breakpoint: 'smallest',
        enter: function() { $('body').addClass('device-xxs'); },
        exit: function() { $('body').removeClass('device-xxs'); }
      }
    ]);
  }

  /* ---------------------------------------------
    DataResponsiveHeights
   --------------------------------------------- */
  function kt_dataResponsiveHeights(){
    var $dataHeightXxs = $('[data-height-xxs]'),
        $dataHeightXs = $('[data-height-xs]'),
        $dataHeightSm = $('[data-height-sm]'),
        $dataHeightMd = $('[data-height-md]'),
        $dataHeightLg = $('[data-height-lg]');

    if( $dataHeightXxs.length > 0 ) {
      $dataHeightXxs.each( function(){
        var element = $(this),
            elementHeight = element.attr('data-height-xxs');

        if( $('body').hasClass('device-xxs') ) {
          if( elementHeight != '' ) { element.css( 'height', elementHeight ); }
        }
      });
    }

    if( $dataHeightXs.length > 0 ) {
      $dataHeightXs.each( function(){
        var element = $(this),
            elementHeight = element.attr('data-height-xs');

        if( $('body').hasClass('device-xs') ) {
          if( elementHeight != '' ) { element.css( 'height', elementHeight ); }
        }
      });
    }

    if( $dataHeightSm.length > 0 ) {
      $dataHeightSm.each( function(){
        var element = $(this),
            elementHeight = element.attr('data-height-sm');

        if( $('body').hasClass('device-sm') ) {
          if( elementHeight != '' ) { element.css( 'height', elementHeight ); }
        }
      });
    }

    if( $dataHeightMd.length > 0 ) {
      $dataHeightMd.each( function(){
        var element = $(this),
            elementHeight = element.attr('data-height-md');

        if( $('body').hasClass('device-md') ) {
          if( elementHeight != '' ) { element.css( 'height', elementHeight ); }
        }
      });
    }

    if( $dataHeightLg.length > 0 ) {
      $dataHeightLg.each( function(){
        var element = $(this),
            elementHeight = element.attr('data-height-lg');

        if( $('body').hasClass('device-lg') ) {
          if( elementHeight != '' ) { element.css( 'height', elementHeight ); }
        }
      });
    }
  }



  /* ---------------------------------------------
     Resize mega menu
     --------------------------------------------- */
  function kt_resizeMegamenu(){
    var window_size = jQuery('body').innerWidth();
    window_size += kt_get_scrollbar_width();
    if( window_size > 767 ){
      if( $('.main-menu-wapper').length >0){
        var container = $('.main-menu-wapper');
        if( container!= 'undefined'){
          var container_width = 0;
          container_width = container.innerWidth();
          var container_offset = container.offset();
          setTimeout(function(){
            $('.main-menu .item-megamenu').each(function(index,element){
              $(element).children('.megamenu').css({'max-width':container_width+'px'});
              var sub_menu_width = $(element).children('.megamenu').outerWidth();
              var item_width = $(element).outerWidth();
              $(element).children('.megamenu').css({'left':'-'+(sub_menu_width/2 - item_width/2)+'px'});
              var container_left = container_offset.left;
              var container_right = (container_left + container_width);
              var item_left = $(element).offset().left;
              var overflow_left = (sub_menu_width/2 > (item_left - container_left));
              var overflow_right = ((sub_menu_width/2 + item_left) > container_right);
              if( overflow_left ){
                var left = (item_left - container_left);
                $(element).children('.megamenu').css({'left':-left+'px'});
              }
              if( overflow_right && !overflow_left ){
                var left = (item_left - container_left);
                left = left - ( container_width - sub_menu_width );
                $(element).children('.megamenu').css({'left':-left+'px'});
              }
            })
          },100);
        }
      }
    }
  }

  function kt_get_scrollbar_width() {
    var $inner = jQuery('<div style="width: 100%; height:200px;">test</div>'),
        $outer = jQuery('<div style="width:200px;height:150px; position: absolute; top: 0; left: 0; visibility: hidden; overflow:hidden;"></div>').append($inner),
        inner = $inner[0],
        outer = $outer[0];
    jQuery('body').append(outer);
    var width1 = inner.offsetWidth;
    $outer.css('overflow', 'scroll');
    var width2 = outer.clientWidth;
    $outer.remove();
    return (width1 - width2);
  }

  /* ---------------------------------------------
     Menu mega style 2
     --------------------------------------------- */
  function kt_Megamenustyle2(){
    var window_size = jQuery('body').innerWidth();
    window_size += kt_get_scrollbar_width();
    if( window_size > 767 ){
      if( $('.item-megamenu.style2').length >0){
        $(".item-megamenu.style2 li a").hover( function () {
          $(".item-megamenu.style2 li a").removeClass('active');
          $(this).addClass('active');
          var menuopen= $(this).attr("data-menuopen");
          $('.level_wrapper ').css({
            display: 'none'
          });
          $('.'+menuopen+'').css({
            display: 'block'
          });

        });

        $(".item-megamenu.style2 .sub-menu.megamenu").mouseout(function(event) {
          $(".item-megamenu.style2 li").first().find('a').addClass('active');

          $('.item-megamenu.style2 level_wrapper').css({
            display: 'none'
          });
          $(".item-megamenu.style2 level_wrapper").first().css({
            display: 'block'
          });
        });
      }
    }
  }

  /**==============================
   Auto width Vertical menu
   ===============================**/
  function kt_auto_width_vertical_menu(){
    var full_width = parseInt($('.container').innerWidth());

    //full_width = $( document ).width();
    var menu_width = parseInt($('.verticalmenu-content').actual('width'));
    var w = (full_width - menu_width)-32;
    $('.verticalmenu-content').find('.megamenu').each(function(){

      $(this).css('max-width',w+'px');
    });
  }

  /* ---------------------------------------------
     COUNTDOWN
     --------------------------------------------- */
  function kt_countdown(){
    if($('.kt-countdown').length >0){
      var labels = ['Years', 'Months', 'Weeks', 'Days', 'Hours', 'Minutes', 'Seconds'];
      var layout = '<span class="box-count day"><span class="number">{dnn}</span> <span class="text">Days</span></span><span class="dot">:</span><span class="box-count hrs"><span class="number">{hnn}</span> <span class="text">Hours</span></span><span class="dot">:</span><span class="box-count min"><span class="number">{mnn}</span> <span class="text">Minutes</span></span><span class="dot">:</span><span class="box-count secs"><span class="number">{snn}</span> <span class="text">Seconds</span></span>';
      $('.kt-countdown').each(function() {
        var austDay = new Date($(this).data('y'),$(this).data('m') - 1,$(this).data('d'),$(this).data('h'),$(this).data('i'),$(this).data('s'));
        $(this).countdown({
          until: austDay,
          labels: labels,
          layout: layout
        });
      });
    }
  }

  /* ---------------------------------------------
     LIGHTBOX
   --------------------------------------------- */
  function lightbox(){
    var $lightboxImageEl = $('[data-lightbox="image"]'),
        $lightboxGalleryEl = $('[data-lightbox="gallery"]'),
        $lightboxIframeEl = $('[data-lightbox="iframe"]'),
        $lightboxInlineEl = $('[data-lightbox="inline"]'),
        $lightboxAjaxEl = $('[data-lightbox="ajax"]'),
        $lightboxAjaxGalleryEl = $('[data-lightbox="ajax-gallery"]');

    if( $lightboxImageEl.length > 0 ) {
      $lightboxImageEl.magnificPopup({
        type: 'image',
        closeOnContentClick: true,
        closeBtnInside: false,
        fixedContentPos: true,
        mainClass: 'mfp-no-margins mfp-fade', // class to remove default margin from left and right side
        image: {
          verticalFit: true
        }
      });
    }

    if( $lightboxGalleryEl.length > 0 ) {
      $lightboxGalleryEl.each(function() {
        var element = $(this);

        if( element.find('a[data-lightbox="gallery-item"]').parent('.clone').hasClass('clone') ) {
          element.find('a[data-lightbox="gallery-item"]').parent('.clone').find('a[data-lightbox="gallery-item"]').attr('data-lightbox','');
        }

        element.magnificPopup({
          delegate: 'a[data-lightbox="gallery-item"]',
          type: 'image',
          closeOnContentClick: true,
          closeBtnInside: false,
          fixedContentPos: true,
          mainClass: 'mfp-no-margins mfp-fade', // class to remove default margin from left and right side
          image: {
            verticalFit: true
          },
          gallery: {
            enabled: true,
            navigateByImgClick: true,
            preload: [0,1] // Will preload 0 - before current, and 1 after the current image
          }
        });
      });
    }

    if( $lightboxIframeEl.length > 0 ) {
      $lightboxIframeEl.magnificPopup({
        disableOn: 600,
        type: 'iframe',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
      });
    }

    if( $lightboxInlineEl.length > 0 ) {
      $lightboxInlineEl.magnificPopup({
        type: 'inline',
        mainClass: 'mfp-no-margins mfp-fade',
        closeBtnInside: false,
        fixedContentPos: true
      });
    }

    if( $lightboxAjaxEl.length > 0 ) {
      $lightboxAjaxEl.magnificPopup({
        type: 'ajax',
        closeBtnInside: false,
        callbacks: {
          ajaxContentAdded: function(mfpResponse) {
            SEMICOLON.widget.loadFlexSlider();
            SEMICOLON.initialize.resizeVideos();
            SEMICOLON.widget.masonryThumbs();
          },
          open: function() {
            $body.addClass('ohidden');
          },
          close: function() {
            $body.removeClass('ohidden');
          }
        }
      });
    }

    if( $lightboxAjaxGalleryEl.length > 0 ) {
      $lightboxAjaxGalleryEl.magnificPopup({
        delegate: 'a[data-lightbox="ajax-gallery-item"]',
        type: 'ajax',
        closeBtnInside: false,
        gallery: {
          enabled: true,
          preload: 0,
          navigateByImgClick: false
        },
        callbacks: {
          ajaxContentAdded: function(mfpResponse) {
            SEMICOLON.widget.loadFlexSlider();
            SEMICOLON.initialize.resizeVideos();
            SEMICOLON.widget.masonryThumbs();
          },
          open: function() {
            $body.addClass('ohidden');
          },
          close: function() {
            $body.removeClass('ohidden');
          }
        }
      });
    }
  }
  /* ---------------------------------------------
     PORTFOLIO FILTER
   --------------------------------------------- */
  /* ---------------------------------------------
     Init popup
     --------------------------------------------- */
  function init_popup(){
    if($(window).width() + kt_get_scrollbar_width() >= 768){
      if($('body').hasClass('home')){
        //Open directly via API
        $.magnificPopup.open({
          items: {
            src: '<div class="white-popup"><div class="kt-popup-newsletter"><div class="popup-title"><img src="images/logo-home2.png" alt="Molly Logo"><p class="notice">enter your email and get  <span class="text-primary">25% off</span> YOUR first purchase!</p></div><form class="form-subscribe"><input class="input" placeholder="Your email here" type="text" /><button class="button button-3">NO THANKS!</button><button class="button button-3 primary">Enter</button></form><div class="checkbox"><label><input type="checkbox" value="">Dont show this popup again!</label></div></div></div>',  //can be a HTML string, jQuery object, or CSS selector
            type: 'inline'
          }
        });
      }
    }
  }

  /* ---------------------------------------------
     Scripts initialization
     --------------------------------------------- */
  $(window).load(function() {
    kt_stick_menu();
    kt_responsiveClasses();
    kt_dataResponsiveHeights()
    kt_resizeMegamenu();
    kt_Megamenustyle2();
    kt_auto_width_vertical_menu();
    kt_hiden_orther_veticalmenu();
    mobileNavigation();
    topsearch();
    $('body.device-sm #btn-cate, body.device-md #btn-cate').prop( "checked", true );
    lightbox();
    if($('#portfolio').length === 1){
    var $container = $('.template-blog #portfolio >div');

    $container.isotope({ transitionDuration: '0.65s' });

    $('.template-blog #portfolio-filter a').click(function(){
      $('.template-blog #portfolio-filter li').removeClass('activeFilter');
      $(this).parent('li').addClass('activeFilter');
      var selector = $(this).attr('data-filter');
      $container.isotope({ filter: selector });
      return false;
    });

    $(window).resize(function() {
      $container.isotope('layout');
    });
    }
    init_popup();
  });

  /* ---------------------------------------------
     Scripts scroll
     --------------------------------------------- */
  $(window).scroll(function(){
    kt_stick_menu();
    kt_resizeMegamenu();
    kt_Megamenustyle2();
    // Show hide scrolltop button
    if( $(window).scrollTop() == 0 ) {
      $('.scroll_top').stop(false,true).fadeOut(600);
    }else{
      $('.scroll_top').stop(false,true).fadeIn(600);
    }
  });

  /* ---------------------------------------------
     Scripts resize
     --------------------------------------------- */
  $(window).on("resize", function() {
    kt_stick_menu();
    $('body.device-sm #btn-cate, body.device-md #btn-cate').prop( "checked", true );
    kt_responsiveClasses();
    kt_dataResponsiveHeights()
    kt_resizeMegamenu();
    kt_Megamenustyle2();
    kt_auto_width_vertical_menu();
    kt_auto_width_vertical_menu();
  });

  /* ---------------------------------------------
     Scripts ready
     --------------------------------------------- */
  $(document).ready(function() {
    kt_stick_menu();  
    //SELECT CHOSEN
    $("select").chosen();
    $('.has-child.item-megamenu').trigger('click');
    $('.has-child.item-megamenu').mousemove(function(event) {
      kt_resizeMegamenu();
    });
    kt_Megamenustyle2();
    //set a waypoint for all the page parts on the page
    var MWaypoint = $('.countTo').waypoint(function(direction) {
      //check the direction
      if(direction == 'down') {
        $('.counter').countTo();
      }
    }, {
      //Set the offset
      offset: '80%'
    });
    // Scroll top
    $(document).on('click','.scroll_top',function(){
      $('body,html').animate({scrollTop:0},400);
      return false;
    });

    kt_countdown();
    // CATEGORY FILTER
    $('.slider-range-price').each(function(){
      var min             = $(this).data('min');
      var max             = $(this).data('max');
      var unit            = $(this).data('unit');
      var value_min       = $(this).data('value-min');
      var value_max       = $(this).data('value-max');
      var label_reasult   = $(this).data('label-reasult');
      var t               = $(this);
      $( this ).slider({
        range: true,
        min: min,
        max: max,
        values: [ value_min, value_max ],
        slide: function( event, ui ) {
          var result = label_reasult +" <span>"+ unit + ui.values[ 0 ] +' </span> - <span> '+ unit +ui.values[ 1 ]+'</span>';
          t.closest('.price_slider_wrapper').find('.amount-range-price').html(result);
        }
      });
    });
    $(document).on('click', '.product-categories .has-child .arrow-down', function(event) {
      event.preventDefault();
      $('.product-categories .has-child').not($(this).closest('li')).removeClass('clicked');
      $(this).closest('li').toggleClass('clicked');
      $(this).attr('class','arrow-up');
    });
    $(document).on('click', '.product-categories .has-child .arrow-up', function(event) {
      event.preventDefault();
      $('.product-categories .has-child').not($(this).closest('li')).removeClass('clicked');
      $(this).closest('li').toggleClass('clicked');
      $(this).attr('class','arrow-down');
    });
    // Instantiate EasyZoom instances

    //    var $easyzoom = $('.easyzoom ').easyZoom();
    //  // Setup thumbnails example
    // //var api1 = $easyzoom.data('easyZoom');
    //  $('.kt-zoom-thumbnails').on('click', 'a', function(e) {
    //    var $this = $(this); 
    //    e.preventDefault();
    //    // Use EasyZoom's `swap` method
    //     $easyzoom.data('easyZoom').swap($this.data('standard'), $this.attr('href'));
    //     console.log($this.data('standard'), $this.attr('href'));
    //  });
//     $("#product-zoom").elevateZoom(zoomConfig); 
//     $("#product-zoom").bind("click", function(e) {  
//       var ez =   $('#product-zoom').data('elevateZoom'); 
//       $.fancybox(ez.getGalleryList());
//       return false;
//     });


    //Qty
    // This button will increment the value
    $('body').on('click','.qtyplus',function(e){
      // Stop acting like a button
      e.preventDefault();
      // Get the field name
      var fieldName = $(this).attr('field');
      // Get its current value
      var currentVal = parseInt($('input[name='+fieldName+']').val());
      var check_max = parseInt($(this).prev('input[name='+fieldName+']').attr('max'));
      check_max = (isNaN(check_max)) ? 1 : check_max;
      // If is not undefined
      if (!isNaN(currentVal)) {
        // Increment
        currentVal = (check_max > currentVal + 1) ? currentVal+1 : check_max;
        $(this).prev('input[name='+fieldName+']').val(currentVal).attr('value',currentVal);
      } else {
        // Otherwise put a 0 there
        $(this).prev('input[name='+fieldName+']').val(0);
      }
    });
    // This button will decrement the value till 0
    $('body').on('click',".qtyminus",function(e) {
      // Stop acting like a button
      e.preventDefault();
      // Get the field name
      var fieldName = $(this).attr('field');
      // Get its current value
      var currentVal = parseInt($('input[name='+fieldName+']').val());
      // If it isn't undefined or its greater than 0
      if (!isNaN(currentVal) && currentVal > 0) {
        // Decrement one
        $(this).next('input[name='+fieldName+']').val(currentVal - 1).attr('value',currentVal - 1);
      } else {
        // Otherwise put a 0 there
        $(this).next('input[name='+fieldName+']').val(0).attr('value',0);
      }
    });

  });

})(jQuery); // End of use strict
